import { breadcrumbSlice } from './breadcrumbSlice'

export const { addBreadcrumb, initialBreadcrumb } = breadcrumbSlice.actions
